'use client';

import React from 'react';
import { useDispatch } from 'react-redux';
import { setTermsContentKeys, setTermsTitleKeys } from '@/slice/terms';

function FooterTermsButton({
  buttonName,
  termsTitleKeys,
  termsContentKey,
  style,
}: {
  buttonName: string;
  termsTitleKeys: string;
  termsContentKey: '' | 'service' | 'privacy' | 'refund' | 'specialLaw';
  style?: { [key: string]: string } | undefined;
}) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setTermsContentKeys(termsContentKey));
    dispatch(setTermsTitleKeys(termsTitleKeys));
  };

  return (
    <button style={style} onClick={handleClick}>
      {buttonName}
    </button>
  );
}

export default FooterTermsButton;
